import React, { FC } from 'react';
import cls from './Form.module.css';
import classNames from 'classnames';

export const Form = ({ children }) => {
    return <form className={classNames(cls.form)}>{children}</form>;
};
